import React from 'react'
import styled, { css } from 'styled-components/macro'
import { theme, ifProp, ifNotProp } from 'styled-tools'
import { rgba, color } from '../../utils/styles';

const getColor = ifProp('current', color('base'), rgba('base', 0.4));

const StepNavItemBase = styled.li``

const StepNavItemContent = styled.a`
  display: block;
  position: relative;
  margin: 0;
  padding: 0 0 .25em;
  color: ${getColor};
  font-weight: ${theme('fontWeights.bold')};
  text-align: center;
  text-decoration: none;
  transition: color 150ms ease-out;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-bottom: 4px solid ${getColor};
    transform: ${ifProp('current', 'scaleX(1)', 'scaleX(0)')};
    transition: transform 200ms ease-out;
  }

  ${ifNotProp('disabled', css`
    &:hover::after {
      transform: scaleX(1);
    }
  `)}
`

function StepNavItem({
  disabled,
  as,
  children,
  ...props
}) {
  return (
    <StepNavItemBase>
      <StepNavItemContent
        {...props}
        as={disabled ? 'span' : as}
        disabled={disabled}
      >
        {children}
      </StepNavItemContent>
    </StepNavItemBase>
  )
}

export default StepNavItem
